export const customStyles = {
  header: {
    style: {
      fontSize: '17px',
      fontWeight: 'bold',
      minHeight: '40px',
      paddingLeft: '16px',
      paddingRight: '8px',
      borderRadius: '20px 20px 0 0',
      whiteSpace: 'nowrap',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#637BFE',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 'bold',
      minHeight: '40px',
      borderRadius: '0 0 20px 20px',
      borderBottom: 'none',
      alignItems: 'center',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    denseStyle: {
      minHeight: '32px',
    },
  },
  subHeader: {
    style: {
      minHeight: '0px',
      marginTop: -14,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.09)',
    },
  },
  headCells: {
    style: {
      fontSize: '14px',
      color: 'white',
      fontWeight: 'bold',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  },
  cells: {
    style: {
      textAlign: 'center',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      fontSize: '13px',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  fixedHeader: {
    style: {
      backgroundColor: '#637BFE',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 'bold',
      minHeight: '40px',
      minWidth: '100px',
      borderBottom: 'none',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      fontFamily: ['Euclid Circular A', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(', '),
      fontOpticalSizing: 'auto',
      fontWeight: 400,
      fontStyle: 'normal',
      color: 'black',
      minHeight: '50px',
      textAlign: 'center',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      '&:not(:last-of-type)': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '0px',
      },
      '&:hover': {
        backgroundColor: '#f9fafc',
      },
    },
  },
  pagination: {
    style: {
      fontSize: '13px',
      minHeight: '50px',
      borderRadius: '0 0 20px 20px',
      textAlign: 'left',
    },
    pageButtonsStyle: {
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: 'red',
        fill: '#5A5858',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#EBF1FE',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#3E79F7',
      },
    },
  },
};
